import { render } from "./BooleanQuestion.vue?vue&type=template&id=6122cfbf"
import script from "./BooleanQuestion.vue?vue&type=script&lang=ts"
export * from "./BooleanQuestion.vue?vue&type=script&lang=ts"

import "./BooleanQuestion.vue?vue&type=style&index=0&id=6122cfbf&lang=scss"
script.render = render

export default script